import GroceryOrdersListPanel from '../../components/grocery/GroceryOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function MerchantGroceryLiveOrdersPage() {
  return (
    <PageShell>
      <PageHeader
        title="Live Grocery Orders"
        subtitle="Accept store orders, pack items, mark ready, and track delivery"
      />
      <GroceryOrdersListPanel
        scope="live"
        title="Active grocery orders"
        queryKeyPrefix="merchant-grocery-live"
      />
    </PageShell>
  );
}
